import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AutomationModule } from '@frontend/sports/automation/core-feature';
import { EffectsModule } from '@ngrx/effects';
import { ShowInEpcotDirective } from 'packages/sports/web/app/src/common/epcot-config.directive';
import { SliderComponent } from 'packages/sports/web/app/src/common/slider/slider.component';
import { DirectivesModule } from 'packages/sports/web/app/src/directives/directives.module';
import { HelpBoxComponent } from 'packages/sports/web/app/src/help-box/help-box.component';

import BetslipDigitalBetPlacementModule from '../betplacement/betslip-digital-betplacement.module';
import { BetslipDigitalCommonModule } from '../common/digital-module';
import { InfoMessageContainerComponent } from '../info-messages/info-message-container/info-message-container.component';
import { LinearBetslipModule } from '../linear/linear-betslip-module';
import BetslipDigitalPicksModule from '../picks/betslip-digital-picks.module';
import PickOddsModule from '../picks/pick-odds.module';
import { DigitalRewardTokensModule } from '../reward-tokens/digital-reward-tokens.module';
import BetslipDigitalStakeModule from '../stake/betslip-digital-stake.module';
import BetslipDigitalSummaryModule from '../summary/betslip-digital-summary.module';
import BetslipDigitalValidationModule from '../validation/betslip-digital-validation.module';
import { TeaserBetContainerComponent } from './components/teaser-bet-container/teaser-bet-container.component';
import { TeaserBetHeaderComponent } from './components/teaser-bet-header/teaser-bet-header.component';
import TeaserBetLinearSummaryComponent from './components/teaser-bet-linear-summary/teaser-bet-linear-summary.component';
import TeaserBetLinearComponent from './components/teaser-bet-linear/teaser-bet-linear.component';
import TeaserBetPickComponent from './components/teaser-bet-pick/teaser-bet-pick.component';
import { TeaserBetPlaceBetButtonContainerComponent } from './components/teaser-bet-place-bet/teaser-bet-place-bet-button-container.component';
import { TeaserBetPointSelectorComponent } from './components/teaser-bet-point-selector/teaser-bet-point-selector.component';
import { TeaserBetSummaryContainerComponent } from './components/teaser-bet-summary/teaser-bet-summary-container.component';
import { TeaserBetComponent } from './components/teaser-bet/teaser-bet.component';
import { TeaserBetCdsEffects } from './effects/teaser-bet-cds.effects';
import TeaserBetLinearEffects from './effects/teaser-bet-linear.effects';
import { TeaserBetPlaceBetEffects } from './effects/teaser-bet-place-bet.effects';
import { TeaserBetStakeEffects } from './effects/teaser-bet-stake.effects';
import { TeaserBetEffects } from './effects/teaser-bet.effects';
import { TeaserBetApiService } from './services/teaser-bet-api.service';
import { TeaserBetErrorStateService } from './services/teaser-bet-errors-state.service';
import { TeaserBetFilterService } from './services/teaser-bet-filter.service';
import { TeaserBetNewService } from './services/teaser-bet-new.service';
import { TeaserBetPickSubscriptionService } from './services/teaser-bet-pick-subscription.service';
import TeaserBetStateStorageService from './services/teaser-bet-state-storage.service';
import { TeaserBetTrackingService } from './services/teaser-bet-tracking.service';
import { TeaserBetTrackingEffects } from './teaser-bet-tracking.effects';

export const components = [
    TeaserBetContainerComponent,
    TeaserBetComponent,
    TeaserBetPickComponent,
    TeaserBetSummaryContainerComponent,
    TeaserBetPlaceBetButtonContainerComponent,
    TeaserBetPointSelectorComponent,
    TeaserBetHeaderComponent,
    TeaserBetLinearComponent,
    TeaserBetLinearSummaryComponent,
];

@NgModule({
    declarations: [...components],
    imports: [
        CommonModule,
        DirectivesModule,
        BetslipDigitalCommonModule,
        BetslipDigitalPicksModule,
        BetslipDigitalStakeModule,
        BetslipDigitalSummaryModule,
        BetslipDigitalBetPlacementModule,
        BetslipDigitalValidationModule,
        ShowInEpcotDirective,
        EffectsModule.forFeature([
            TeaserBetEffects,
            TeaserBetTrackingEffects,
            TeaserBetCdsEffects,
            TeaserBetStakeEffects,
            TeaserBetPlaceBetEffects,
            TeaserBetLinearEffects,
        ]),
        PickOddsModule,
        AutomationModule,
        SliderComponent,
        HelpBoxComponent,
        DigitalRewardTokensModule,
        LinearBetslipModule,
        ShowInEpcotDirective,
        InfoMessageContainerComponent,
    ],
    exports: [...components],
    providers: [
        TeaserBetFilterService,
        TeaserBetStateStorageService,
        TeaserBetErrorStateService,
        TeaserBetTrackingService,
        TeaserBetPickSubscriptionService,
        TeaserBetNewService,
        TeaserBetApiService,
    ],
})
export class BetslipDigitalTeaserModule {}
